import { Microphone } from '@tunasong/icons'
import type { Entity, Persisted } from '@tunasong/schemas'
import type { FabProps } from '@tunasong/ui-lib'
import { Fab, useUploadStoredEntity } from '@tunasong/ui-lib'
import { useState, type MouseEvent } from 'react'
import { RecordDialog } from './record-dialog.js'

export interface RecordFabButtonProps extends Omit<FabProps, 'onClick' | 'position'> {
  parent?: Persisted<Entity>
  position?: 'fixed' | 'relative'
}

export const RecordFabButton = (props: RecordFabButtonProps) => {
  const { parent, ...restProps } = props

  const { isUploading } = useUploadStoredEntity()

  const [open, setOpen] = useState(false)

  const handleClick = (ev: MouseEvent) => {
    ev.stopPropagation()
    setOpen(true)
  }

  return (
    <>
      <RecordDialog open={open} onClose={() => setOpen(false)} parent={parent} />
      <Fab aria-label="Record" disabled={isUploading} onClick={handleClick} {...restProps}>
        <Microphone />
      </Fab>
    </>
  )
}
